module.exports = __webpack_public_path__ + "img/landing_box51.d70b5bfb.jpg";